// 设置过期时间以秒为单位
export function setCookie(c_name, value, expireseconds, path){
  const exdate = new Date();
  exdate.setTime(exdate.getTime() + expireseconds * 1000);

  document.cookie= c_name + "=" + escape(value) +
  ((expireseconds==null) ? "" : ";expires="+exdate.toGMTString()) +
  (path ? ";path="+path : ";path=/")
}
// setCookie('userName','xxx',3600);  //cookie过期时间为一个小时

// 函数中的参数为 要获取的cookie键的名称。
export function getCookie(userName){
  if (document.cookie.length>0){
    let c_start = document.cookie.indexOf(userName+ "=");
    if (c_start != -1){
      c_start = c_start + userName.length + 1;
      let c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1){ 
        c_end = document.cookie.length;
      }
      return unescape(document.cookie.substring(c_start, c_end));
    }
  }
  return "";
}

// 刷新_ati
export function reset_ati() {
  setCookie("_ati", _.random(1000000000000, 9999999999999), null)
}

export default {
  set: setCookie,
  get: getCookie,
  reset_ati
}
